<mat-card class="d-flex align-items-center mat-elevation-z0">
    <mat-spinner diameter="{{ small ? '25' : '50' }}"></mat-spinner>
    <strong *ngIf="!small" class="p-t-10">{{ (message ? message : 'liste.loading') | translate }}</strong>
    <span *ngIf="!small && !message" [translate]="'liste.pleaseWait'"></span>
</mat-card>